// Rejoue les effets de page (app/pageEffects.ts) après chaque navigation.
import { useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import { runPageEffects } from '@/app/pageEffects'

export default function PageEffects() {
  const { url, component } = usePage()
  useEffect(() => runPageEffects(document.getElementById('main-content') || document), [url, component])
  return null
}
